// Localized names/descriptions for generated-document templates.
// Stored template.name is English (seeded from StandardTemplateRegistry);
// RendererMetadata descriptions are English C# strings. The UI keys off
// purpose / standardTemplateKey and falls back to the server string.

export function templateName(template, t) {
  if (template?.standardTemplateKey) {
    const key = `template_name_${template.standardTemplateKey.replace(/-/g, "_")}`;
    const translated = t(key);
    if (translated !== key) return translated;
  }
  return template?.name ?? "";
}

export function templateDescription(template, t) {
  if (!template?.purpose) return template?.description ?? "";
  const key = `template_desc_${template.purpose}`;
  const translated = t(key);
  return translated !== key ? translated : (template.description ?? "");
}

export function templatePurposeLabel(purpose, t) {
  if (!purpose) return "";
  const key = `template_purpose_${purpose}`;
  const translated = t(key);
  return translated !== key ? translated : purpose;
}
